import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Flex } from 'Components/Base';
import Loading from 'Components/Loading';
import { useConfig } from 'Context/ConfigContext';
import { useCapacitor } from 'Util/Capacitors';

const LoginBypass = () => {
  const { openUrl, setUserProvider } = useCapacitor();
  const { skooldioLogin } = useConfig();
  const { provider } = useParams();

  useEffect(() => {
    const passportProviders = skooldioLogin?.passportProviders ?? [];
    const providerConfig = passportProviders.find(
      (passportProvider) => passportProvider.provider === provider
    );

    if (providerConfig) {
      const { loginURL } = providerConfig;
      setUserProvider(provider);
      openUrl(loginURL, { closeOther: true });
    } else {
      window.location = '/';
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skooldioLogin.passportProviders, provider]);

  return (
    <Flex justifyContent={'center'} alignItems={'center'} height={'100vh'}>
      <Loading />
    </Flex>
  );
};

export default LoginBypass;
